import React from 'react';
import './DashboardDetailed.css';
import { useSelector } from 'react-redux';
import { FaClock, FaReceipt, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);
  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Mock data - replace with actual data from API
  const summaryData = {
    pendingTimeSheets: 2,
    pendingExpenses: 3,
    pendingApprovals: 5,
    overdueItems: 1
  };

  const recentActivity = [
    {
      id: 1,
      type: 'timesheet',
      title: 'Time Sheet Pending',
      date: '2024-03-15',
      icon: <FaClock />,
      color: 'blue'
    },
    {
      id: 2,
      type: 'expense',
      title: 'Expense Report Approved',
      date: '2024-03-14',
      icon: <FaReceipt />,
      color: 'green'
    },
    {
      id: 3,
      type: 'approval',
      title: 'New Approval Request',
      date: '2024-03-13',
      icon: <FaCheckCircle />,
      color: 'yellow'
    }
  ];

  return (
    <div className="dashboard-detailed-container">
      <div className="dashboard-welcome-section">
        <h1 className="dashboard-welcome-text">Welcome back, {user?.firstName || 'User'}!</h1>
        <p className="dashboard-date-text">{currentDate}</p>
      </div>

      <div className="dashboard-cards-grid">
        <div className="dashboard-card">
          <div className="dashboard-card-icon blue">
            <FaClock />
          </div>
          <div className="dashboard-card-content">
            <h3 className="dashboard-card-title">Pending Time Sheets</h3>
            <div className="dashboard-card-value">{summaryData.pendingTimeSheets}</div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="dashboard-card-icon green">
            <FaReceipt />
          </div>
          <div className="dashboard-card-content">
            <h3 className="dashboard-card-title">Pending Expenses</h3>
            <div className="dashboard-card-value">{summaryData.pendingExpenses}</div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="dashboard-card-icon yellow">
            <FaCheckCircle />
          </div>
          <div className="dashboard-card-content">
            <h3 className="dashboard-card-title">Pending Approvals</h3>
            <div className="dashboard-card-value">{summaryData.pendingApprovals}</div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="dashboard-card-icon red">
            <FaExclamationTriangle />
          </div>
          <div className="dashboard-card-content">
            <h3 className="dashboard-card-title">Overdue Items</h3>
            <div className="dashboard-card-value">{summaryData.overdueItems}</div>
          </div>
        </div>
      </div>

      <h2 className="dashboard-section-title">Recent Activity</h2>
      <div className="dashboard-recent-activity">
        <div className="dashboard-activity-list">
          {recentActivity.map((activity) => (
            <div className="dashboard-activity-item" key={activity.id}>
              <div className={`dashboard-activity-icon ${activity.color}`}>
                {activity.icon}
              </div>
              <div className="dashboard-activity-content">
                <div className="dashboard-activity-title">{activity.title}</div>
                <div className="dashboard-activity-date">{activity.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 